module.exports = __webpack_public_path__ + "img/pak.c2e1a159.svg";